module.exports = __webpack_public_path__ + "img/ill_spot_search.eb011a3b.svg";